import { RouteConfig } from "vue-router";

const newContainer = () => import("@/layouts/Default.vue");
import exportMainSearch from "./../views/../views/report/exportMainSearch.vue";
import finalReportSearch from "./../views/finalReport/finalReportSearch.vue";
import finalReportVotes from "./../views/finalReport/finalReportVotes.vue";
import finalReportVotes2 from "./../views/finalReport/finalReportVotes2.vue";
// import readyQualification from "../views/finalReport/readyQualification.vue";
import readyReportAccessSearch from "./../views/report/readyReportAccessSearch.vue";
import readyReportSearch from "../views/report/readyReportSearch.vue";
import reportDashboard from "./../views/dashboard/index.vue";
import reportPaymentsSearch from "./../views/report/reportPaymentsSearch.vue";
const routerParent = () => import("@/components/base/routerParrent.vue");
const searchPaymentNoNeed = () =>
  import("../views/payment/searchPaymentNoNeed.vue");
// redesigned
const newDashboard = () => import("../views/re-design/dashboard/index.vue");
// const myPaymentsList = () => import("../views/report/myPaymentsList.vue");

export const reportRoutes: RouteConfig[] = [
  {
    path: "/report",
    name: "dynamic_home",
    meta: {
      label: "خانه",
      requiresAuth: true,
    },
    component: newContainer,
    children: [
      {
        path: "payments",
        name: "payments",
        meta: {
          label: "پرداخت",
          requiresAuth: true,
        },
        component: routerParent,
        redirect: "/report/payments/search",
        children: [
          {
            path: "search",
            name: "report_payment_search",
            component: reportPaymentsSearch,
            meta: {
              label: "لیست سوابق پرداختی",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: "payment-no-need",
            name: "payment_no_need",
            component: searchPaymentNoNeed,
            meta: {
              label: "لیست عدم پرداخت یا تخفیف",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "my-payments",
        name: "my-payments",
        meta: {
          label: "پرداخت های من",
          requiresAuth: true,
          deprecated: true,
        },
        component: routerParent,
        redirect: "/report/my-payments/list",
        children: [
          {
            path: "list",
            name: "my_report_payment_search",
            // component: myPaymentsList,
            meta: {
              label: "لیست سوابق پرداختی",
              deprecated: true,
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "ready-commitment",
        name: "ready_commitment",
        meta: {
          label: "تعیین صلاحیت",
          requiresAuth: true,
          deprecated: true,
        },
        redirect: "/report/ready-commitment/list",
        component: routerParent,
        children: [
          {
            path: "list",
            name: "ready-commitment-list",
            // component: readyCommitmentList,
            meta: {
              label: "آماده اخذ تعهد",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "commitment",
        name: "commitment",
        meta: {
          label: "تعیین صلاحیت",
          requiresAuth: true,
        },
        redirect: "/report/commitment/list",
        component: routerParent,
        children: [
          {
            path: "list",
            name: "commitment-list",
            // component: commitmentList,
            meta: {
              label: "تعهد ها",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "my-responsibility-commitments",
        name: "my_responsibility_commitments",
        meta: {
          label: "تعیین صلاحیت",
          requiresAuth: true,
        },
        redirect: "/report/my-responsibility-commitments/list",
        component: routerParent,
        children: [
          {
            path: "list",
            name: "my-responsibility-commitments-list",
            // component: myResponsibilityCommitmentsList,
            meta: {
              label: "تعهدها با مسئولیت من",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/form",
            name: "my-responsibility-commitments-form",
            // component: myResponsibilityCommitmentsForm,
            meta: {
              label: "مشاهده فرم تعهد‌نامه",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "ready-qualification",
        name: "qualification",
        meta: {
          label: "تعیین صلاحیت",
          requiresAuth: true,
          deprecated: true,
        },
        redirect: "/report/ready-qualification/list",
        component: routerParent,
        children: [
          {
            path: "list",
            name: "ready-qualification-list",
            meta: {
              label: "آماده تعیین صلاحیت",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "final_report",
        name: "final_report",
        meta: {
          label: "تعیین صلاحیت",
          requiresAuth: true,
        },
        redirect: "/report/final_report/search",
        component: {
          render(c: any) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "search",
            name: "finalReportSearch",
            component: finalReportSearch,
            meta: {
              label: "لیست تعیین صلاحیت",
              requiresAuth: true,
            },
          },
          {
            path: "votes/:code",
            name: "finalReportVotes",
            component: finalReportVotes,
            meta: {
              label: "مشاهده گزارش تعیین صلاحیت",
              requiresAuth: true,
            },
          },
          {
            path: "votes2/:code",
            name: "finalReportVotes2",
            component: finalReportVotes2,
            meta: {
              label: "فرم اظهار نظر هیئت تعیین صلاحیت",
              requiresAuth: true,
            },
          },
          {
            path: "votes3/:code",
            name: "finalReportVotes3",
            component: finalReportVotes2,
            meta: {
              label: "فرم اظهار نظر هیئت تعیین صلاحیت",
              requiresAuth: true,
            },
          },
          {
            path: "votes_group/:code",
            name: "finalReportVotesGroup",
            component: finalReportVotes2,
            meta: {
              label: "فرم رای دهی گروهی",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "export-excel",
        name: "export_excel",
        meta: {
          label: "گزارش",
          requiresAuth: true,
          deprecated: true,
        },
        component: routerParent,
        redirect: "/report/export-excel/list",
        children: [
          {
            path: "list",
            name: "export_excel_show",
            component: exportMainSearch,
            meta: {
              label: "خروجی‌های اکسل",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "ready-report",
        name: "ready_report",
        meta: {
          label: "گزارش‌",
          requiresAuth: true,
        },
        component: routerParent,
        redirect: "/report/ready-report/list",
        children: [
          {
            path: "list",
            name: "ready_report",
            component: readyReportSearch,
            meta: {
              label: "گزارش‌های آماده",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: "access",
            name: "ready_report_access",
            component: readyReportAccessSearch,
            meta: {
              label: "سطح دسترسی‌ها",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "dashboard-old",
        name: "report_dashboard_old",
        component: reportDashboard,
        meta: {
          label: "داشبورد گزارش",
          requiresAuth: true,
        },
      },
      {
        path: "dashboard",
        name: "report_dashboard",
        component: newDashboard,
        meta: {
          label: "داشبورد گزارش",
          requiresAuth: true,
          deprecated: true,
          hasMaxWidth: false,
        },
      },
      {
        path: "jobs-log",
        name: "jobs-log",
        redirect: "/report/jobs-log/list",
        meta: {
          label: "تاریخچه همه فرایندها",
          requiredAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "jobs_log",
            meta: {
              label: "تاریخچه همه فرایندها",
              requiredAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "my-jobs-log",
        name: "my-jobs-log",
        redirect: "/report/my-jobs-log/list",
        meta: {
          label: "تاریخچه همه فرایندها",
          requiredAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "my_jobs_log",
            meta: {
              label: "تاریخچه فرایندهای من",
              requiredAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "competency-matrix",
        name: "competency_matrix",
        redirect: "/report/competency-matrix/list",
        meta: {
          label: "ماتریس شایستگی",
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "competency-matrix-list",
            // component: competencyMatrixList,
            meta: {
              label: "ماتریس شایستگی",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/detail",
            name: "competency-matrix-detail",
            // component: competencyMatrixDetail,
            meta: {
              label: "درج داده های تکمیلی ماتریس",
              requiresAuth: true,
              deprecated: true,
              hasBottomNavigation: false,
            },
          },
        ],
      },
    ],
  },
];
